import React from 'react';
import { useDrag, useDrop } from 'react-dnd';
import PropTypes from 'prop-types';
import KanbanCard from './KanbanCard';

export default function KanbanDraggableCard({
  card,
  index,
  columnId,
  moveCard,
  onUpdateCard,
  onCardClick,
  typeCard,
}) {
  const ref = React.useRef(null);
  const dragHandleRef = React.useRef(null);

  const [{ isDragging }, drag] = useDrag({
    type: typeCard,
    item: {
      type: typeCard,
      cardId: card.id,
      card,
      fromColumnId: columnId,
      fromIndex: index,
    },
    collect: monitor => ({ isDragging: monitor.isDragging() }),
  });

  React.useEffect(() => {
    if (dragHandleRef.current) {
      drag(dragHandleRef);
    }
  }, [drag]);

  const [, drop] = useDrop({
    accept: typeCard,

    // hover(item, monitor) {
    //   // if (!ref.current) return;
    //   // if (item.cardId === card.id) return;

    //   // const sameColumn = item.fromColumnId === columnId;
    //   // console.log('sameColumn', sameColumn);
    //   // if (!sameColumn) return;

    //   // const rect = ref.current.getBoundingClientRect();
    //   // const midY = (rect.bottom - rect.top) / 2;
    //   // const client = monitor.getClientOffset();
    //   // const y = client ? client.y - rect.top : 0;

    //   // const dragIndex = item.fromIndex;
    //   // const hoverIndex = index;

    //   // if (dragIndex === hoverIndex) return;
    //   // if (dragIndex < hoverIndex && y < midY) return;
    //   // if (dragIndex > hoverIndex && y > midY) return;

    //   moveCard(item.fromColumnId, dragIndex, columnId, hoverIndex);

    //   // keep the drag item in sync to avoid redundant moves in same column
    //   // eslint-disable-next-line no-param-reassign
    //   item.fromIndex = hoverIndex;
    //   // eslint-disable-next-line no-param-reassign
    //   item.fromColumnId = columnId;
    // },

    // Cross-column insert happens here (on drop), at this card's position
    drop(item) {
      if (item.cardId === card.id) return;

      const sameColumn = item.fromColumnId === columnId;
      if (sameColumn) return; // same-column already handled in hover

      moveCard(item.fromColumnId, item.fromIndex, columnId, index);

      // eslint-disable-next-line no-param-reassign
      item.fromColumnId = columnId;
      // eslint-disable-next-line no-param-reassign
      item.fromIndex = index;
    },
  });

  drag(drop(ref));

  // CLICK — attach on the wrapper; stop propagation on the handle
  const handleCardClick = React.useCallback(() => {
    if (onCardClick) onCardClick(card);
  }, [onCardClick, card]);

  const handleKeyDown = React.useCallback((e) => {
    // Enter ou Espaço acionam o "clique" do botão
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault(); // evita scroll ao apertar Espaço
      handleCardClick();
    }
  }, [handleCardClick]);

  return (
    <div
      ref={ref}
      role="button"
      tabIndex={0}
      onClick={handleCardClick}
      onKeyDown={handleKeyDown}
      style={{
        display: 'flex',
        justifyContent: 'center',
        marginBottom: 8,
        position: 'relative',
        opacity: isDragging ? 0.5 : 1,
        cursor: 'pointer',
      }}
    >
      <KanbanCard
        card={card}
        onUpdate={patch => onUpdateCard(card.id, patch)}
      />
    </div>
  );
}

KanbanDraggableCard.propTypes = {
  card: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,
  index: PropTypes.number.isRequired,
  columnId: PropTypes.number.isRequired,
  moveCard: PropTypes.func.isRequired,
  onUpdateCard: PropTypes.func.isRequired,
  onCardClick: PropTypes.func,
  typeCard: PropTypes.string.isRequired,
};

KanbanDraggableCard.defaultProps = {
  onCardClick: undefined,
};
